"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SLMRewardType;
(function (SLMRewardType) {
    SLMRewardType[SLMRewardType["NONE"] = 0] = "NONE";
    SLMRewardType[SLMRewardType["POINT"] = 1] = "POINT";
    SLMRewardType[SLMRewardType["CASH"] = 2] = "CASH";
    SLMRewardType[SLMRewardType["ADVANCED_COURSE"] = 3] = "ADVANCED_COURSE";
    SLMRewardType[SLMRewardType["TEACHING_AID"] = 4] = "TEACHING_AID";
})(SLMRewardType = exports.SLMRewardType || (exports.SLMRewardType = {}));
//# sourceMappingURL=descartes.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/descartes.js
// module id = 1007
// module chunks = 0